import { render, staticRenderFns } from "./InstructionsDialog.vue?vue&type=template&id=bd7772d4&scoped=true"
import script from "./InstructionsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionsDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstructionsDialog.vue?vue&type=style&index=0&id=bd7772d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7772d4",
  null
  
)

export default component.exports